import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const Home = ()=> import('@/view/home/Home')//首页
const AboutUs = ()=> import('@/view/aboutUs/AboutUs') //关于我们
const NewsMedia = ()=> import('@/view/newsMedia/NewsMedia')//新闻媒体
const IndustryInformation = ()=> import('@/view/newsMedia/industryInformation/IndustryInformation') //行业资讯
const IndustryInformationDetail = ()=> import('@/view/newsMedia/industryInformation/IndustryInformationDetail') //行业资讯详情
const CompanyNews = ()=> import('@/view/newsMedia/companyNews/CompanyNews') //公司新闻
const CompanyNewsDetail = ()=> import('@/view/newsMedia/companyNews/CompanyNewsDetail') //公司新闻详情


const BusinessArea = ()=> import('@/view/businessArea/BusinessArea') //业务领域
const EngineeringPerformance = ()=> import('@/view/engineeringPerformance/EngineeringPerformance') //工程业绩

const ArchitecturalDecoration = ()=> import('@/view/engineeringPerformance/architecturalDecoration/ArchitecturalDecoration')//建筑装饰
// const ArchitecturalDecorationDetail = ()=> import('@/view/engineeringPerformance/architecturalDecoration/ArchitecturalDecorationDetail')//建筑装饰详情
const Exhibition = ()=> import('@/view/engineeringPerformance/exhibition/Exhibition') //展览展示
// const ExhibitionDetail = ()=> import('@/view/engineeringPerformance/exhibition/ExhibitionDetail') //展览展示详情
const BuildingCurtainWall = ()=> import('@/view/engineeringPerformance/buildingCurtainWall/BuildingCurtainWall') //建筑幕墙
// const BuildingCurtainWallDetail = ()=> import('@/view/engineeringPerformance/buildingCurtainWall/BuildingCurtainWallDetail') //建筑幕墙详情
const EngineeringDesign = ()=> import('@/view/engineeringPerformance/engineeringDesign/EngineeringDesign') //工程设计
// const EngineeringDesignDetail = ()=> import('@/view/engineeringPerformance/engineeringDesign/EngineeringDesignDetail') //工程设计详情
const OtherProjects = ()=> import('@/view/engineeringPerformance/otherProjects/OtherProjects') //其它工程
// const OtherProjectsDetail = ()=> import('@/view/engineeringPerformance/otherProjects/OtherProjectsDetail') //其它工程详情

const JoinUs = ()=> import('@/view/joinUs/JoinUs') //加入我们
const ContactUs = ()=> import('@/view/joinUs/contactUs/ContactUs') //联系我们
const JoinYiChengYuan = ()=> import('@/view/joinUs/joinYiChengYuan/JoinYiChengYuan') //加入艺成园
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: {name:'home'},
    },
    {
      path: '/home',//首页
      name: 'home',
      component: Home,
    },
    {
      path: '/aboutUs',//关于我们
      name: 'aboutUs',
      component: AboutUs,
    },
    {
      path: '/newsMedia',//新闻媒体
      name: 'newsMedia',
      component: NewsMedia,
      redirect: {name: 'industryInformation'},
      children: [
        {
          path: 'industryInformation',//行业资讯
          name: 'industryInformation',
          component: IndustryInformation,
          // meta:{
          //   isScroll: true,
          //   scrollT: 700,
          // }
        },
        {
          path: 'industryInformation/detail/:id',//行业资讯详情
          name: 'industryInformationDetail',
          component: IndustryInformationDetail,
        },
        {
          path: 'companyNews',//公司新闻
          name: 'companyNews',
          component: CompanyNews,
        },
        {
          path: 'companyNews/detail/:id',//公司新闻详情
          name: 'companyNewsDetail',
          component: CompanyNewsDetail,
        },
      ]
    },
    {
      path: '/businessArea',//业务领域
      name: 'businessArea',
      component: BusinessArea,
    },
    {
      path: '/engineeringPerformance',//工程业绩
      name: 'engineeringPerformance',
      component: EngineeringPerformance,
      redirect: {name:'architecturalDecoration'},
      children: [
        {
          path: 'architecturalDecoration',//建筑装饰
          name: 'architecturalDecoration',
          component: ArchitecturalDecoration,
          meta:{
            isScroll: true,
            scrollT: 700,
          }
        },
        {
          path: 'exhibition',//展览展示
          name: 'exhibition',
          component: Exhibition,
          meta:{
            isScroll: true,
            scrollT: 700,
          }
        },
        {
          path: 'buildingCurtainWall',//建筑幕墙
          name: 'buildingCurtainWall',
          component: BuildingCurtainWall,
          meta:{
            isScroll: true,
            scrollT: 700,
          }
        },
        {
          path: 'engineeringDesign',//工程设计
          name: 'engineeringDesign',
          component: EngineeringDesign,
          meta:{
            isScroll: true,
            scrollT: 700,
          }
        },
        {
          path: 'otherProjects',//其它工程
          name: 'otherProjects',
          component: OtherProjects,
          meta:{
            isScroll: true,
            scrollT: 700,
          }
        },
      ]
    },
    {
      path: '/joinUs',//加入我们
      name: 'joinUs',
      component: JoinUs,
      redirect: {name: 'contactUs'},
      children: [
        {
          path: 'contactUs',//联系我们
          name: 'contactUs',
          component: ContactUs,
        },
        {
          path: 'joinYiChengYuan',//加入艺成园
          name: 'joinYiChengYuan',
          component: JoinYiChengYuan,
        },
      ]
    },
  ],
  scrollBehavior(to,from,savedPosition) {
    if(to.meta.isScroll && to.query.sort == 'home'){
      return {x:0,y:to.meta.scrollT};
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js